import { i18n } from '@/plugins/i18n'

export default [
    {
        field: 'id',
        title: '#',
        width: 65,
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'transaction_id',
        title: i18n.t('label.reference_id'),
        width: 65,
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'user',
        title: i18n.t('label.user_full_name'),
        template: (row) => {
            return '<a href="/users/' + row.user.id + '/details">'+row.user.fullname+'</a>'
        },
        width: 65,
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'psp',
        title: i18n.t('label.psp'),
        template: (row) => {
            switch(row.psp) {
                case 'mellat':
                    return '<div><img src="/assets/media/psp/mellat.png" width="32" height="32"></div>';
                case 'parsian':
                    return '<div><img src="/assets/media/psp/parsian.svg" width="32" height="32"></div>';
                case 'pasargad':
                    return '<div><img src="/assets/media/psp/pasargad.svg" width="32" height="32"></div>';
                case 'saman':
                    return '<div><img src="/assets/media/psp/saman.svg" width="32" height="32"></div>';
                case 'novin':
                    return '<div><img src="/assets/media/psp/novin.svg" width="32" height="32"></div>';
                case 'sepehr':
                    return '<div><img src="/assets/media/psp/sepehr.png" width="32" height="32"></div>';
                case 'irankish':
                    return '<div><img src="/assets/media/psp/irankish.png" width="32" height="32"></div>';
                case 'asanpardakht':
                    return '<div><img src="/assets/media/psp/ap-logo.png" width="32" height="32"></div>';
            }
            return '<span>' + row.psp + '</span>';
        },
        width: 65,
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'created_at',
        title: i18n.t('label.created_at'),
        width: 80,
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'error_code',
        title: i18n.t('label.error_code'),
        width: 65,
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'error_message',
        title: i18n.t('label.error_message'),
        width: 130,
        sortable: false,
        textAlign: 'center',
    }
]